import { Marker as MapLibreMarker } from 'maplibre-gl'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectGeolocationPosition, selectIsGeoLocationOn } from '../../../store/geolocation/geolocation.selectors'
import { isEqual } from '../../../utils/lang'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { useCompass } from '../../utils/useCompass'
import { withMapInitialized } from '../map.utils'
import { useMapContext } from '../MapContext'
import img from './geolocation_marker_x2.png'
import s from './GeolocMarker.less'

function GeolocMarker() {
  const { map } = useMapContext()

  const position = useSelector(selectGeolocationPosition)
  const geolocationOn = useSelector(selectIsGeoLocationOn)

  const [coords, setCoords] = useState(null)
  const [marker, setMarker] = useState(null)

  const rotation = useCompass(geolocationOn)

  const refDiv = useRef()

  useEffect(() => {
    if (geolocationOn && position && marker && !isEqual(coords, position)) {
      marker.setLngLat(position)
      setCoords(position)
    }
  }, [geolocationOn, position])

  useEffect(() => {
    if (geolocationOn && !marker && position) {
      const m = new MapLibreMarker({
        element: refDiv.current,
        anchor: 'center'
      })
        .setLngLat(position)
        .addTo(map)

      setMarker(m)
    }
  }, [geolocationOn, position])

  useEffect(
    () => () => {
      if (marker) marker.remove()
    },
    [marker]
  )

  if (!geolocationOn || !position) return <></>

  return (
    <div>
      {/* That previous div before refDiv is very important to avoid a crash on umount, see NES-2421 */}
      <div ref={refDiv}>
        <img className={s.imgMarker} src={img} style={{ transform: `rotateZ(${rotation}deg)` }} />
      </div>
    </div>
  )
}

export default withEmptyFallbackErrorBoundary(withMapInitialized(GeolocMarker))
